module.exports = __webpack_public_path__ + "img/certified.74180683.svg";